import { Inject, Injectable } from '@angular/core';
import { clearLocalStorage } from '../environment';
import OktaAuth from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthServiceService {
  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {}
  //todo da decommentare quando si vuole usare il jwt
  /*saveToken(token: string): void {
    if(!localStorage.getItem('jwt_token')){
      localStorage.setItem('jwt_token', encryptObject(token));
    }
  }

  getToken(): string | null {
    return decryptToObject(localStorage.getItem('jwt_token'));
  }

  isLoggedIn(): boolean {
    const token = this.getToken();
    return token != null;
  }

  logOut(){
    localStorage.removeItem('jwt_token');
  }*/
  // todo decommentare e commentare sopra se si vuole usare il cookie service

  isLoggedIn(): boolean {
    const currentUser = localStorage.getItem('CurrentUser');
    return currentUser != null;
  }

  async logOut() {
    if (this.oktaAuth.isAuthenticated()) {
      await this.oktaAuth.signOut({
        postLogoutRedirectUri: null,
        clearTokensBeforeRedirect: true,
      });
    }
    clearLocalStorage();
  }
}
